<template>
  <div>
    <div class="flex items-end justify-start gap-2 w-full">
      <TextInputGuest
        id="gift-card-number-input"
        class="flex-grow"
        forInput="gift-card-number-input"
        v-model.trim="giftCardNumber"
        label="Gift Card Number"
        placeholder="Gift Card Number"
      />
      <TextInputGuest
        class="w-1/5"
        id="gift-card-pin-input"
        forInput="gift-card-pin-input"
        v-model.trim="giftCardPin"
        label="Gift Card Pin"
        placeholder="Gift Card Pin"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue'

import TextInputGuest from '@/common/components/molecules/TextInputGuest.vue'

const giftCardNumber = ref<string>('')
const giftCardPin = ref<string>('')
const isFormValid = computed<boolean>(() => Boolean(giftCardNumber.value && giftCardPin.value))
defineExpose({ giftCardNumber, giftCardPin, isFormValid })
</script>
